import { browser } from '$app/environment';
import { reportClientError } from './lib/modules/report-client-error.js';

export function handleError({ event, error }) {
    const url = window.location.href;
    const userAgent = navigator.userAgent;
    (async () => {
        try {
            await reportClientError(error, url, userAgent, {
                routeId: event.route.id,
                status: error instanceof Error && 'status' in error ? error.status : undefined,
            });
        } catch (err) {
            console.error(`Failed to report error: ${err}`);
        }
    })();

    return console.error({ error, event });
}

// Global error handler for uncaught exceptions outside SvelteKit's rendering
if (browser) {
    window.addEventListener('error', (event) => {
        // Prevent reporting errors already caught by SvelteKit's handleError
        // Or add logic to de-duplicate if necessary
        reportClientError(event.error || new Error(event.message), window.location.href, navigator.userAgent, {
            type: 'unhandled-js-error',
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
        });
    });

    window.addEventListener('unhandledrejection', (event) => {
        reportClientError(
            event.reason instanceof Error ? event.reason : new Error(String(event.reason)),
            window.location.href,
            navigator.userAgent,
            {
                type: 'unhandled-promise-rejection',
            }
        );
    });
}
